<script setup>
import { ref } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import PreviewShapeComponent from '../../components/PreviewShapeComponent.vue';
import slider from 'vue3-slider';
import { router } from '@inertiajs/vue3';

const props = defineProps({
    kaleadical: {
        type: Object,
        default: () => ({
            name: '',
            items: []
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const { store, update, generateAIShape } = useKaleadicalStore();

const form = ref({
    ...props.kaleadical,
});

if (props.mode !== 'Create') {
    form.value.items = form.value.items.map((item) => {
        return {
            ...item,
            code: item.shapes[0].definition,
            scale: item.shapes[0].scale
        };
    });
}

const prompt = ref([]);

const addItem = () => {
    form.value.items.push({
        name: '',
        description: '',
        code: '',
        scale: 1
    });
};

const removeItem = (index) => {
    form.value.items.splice(index, 1);
};

const generateShape = (index) => {
    generateAIShape(prompt.value[index]).then((response) => {
        form.value.items[form.value.items.length - 1].code = response.data.code;
    });
};

const save = async () => {
    const action = props.mode === 'Create' ? store : update;
    await action({
        ...form.value,
    }).then(() => {
        router.visit('/kaleadicals');
    });
};
</script>

<template>
<MainContentLayout>
    <template #title>{{ props.mode === 'Create' ? 'Create' : 'Edit' }} Kaleadical</template>
    <template #actions>
        <StyledButton class="mt-3" @click="save">{{ props.mode === 'Create' ? 'Create' : 'Update' }}</StyledButton>
    </template>
    <form @submit.prevent="save">
        <div>
            <StyledInput
                v-model="form.name"
                name="name"
                label="Title" />
            <div class="space-y-3">
                <div class="flex items-center justify-between">
                    <div class="font-bold text-lg">Items</div>
                    <StyledButton @click="addItem">Add Item</StyledButton>
                </div>
                <div v-for="(item, index) in form.items" :key="index" class="border p-3 rounded shadow">
                    <div class="border-b flex justify-between">
                        <div>Item #{{ index + 1 }}</div>
                        <div class="underline text-orange-800 cursor-pointer hover:text-orange-900" @click="removeItem(index)">Remove</div>
                    </div>
                    <div class="pt-2">
                        <div class="grid grid-cols-2 gap-3">
                            <div>
                                <StyledInput v-model="form.items[index].name" label="Item Title" name="item.name" />
                            </div>
                            <div>
                                <StyledInput v-model="form.items[index].description" label="Item Description" name="item.description" />
                            </div>
                        </div>

                        <div class="flex items-center justify-between pb-1">
                            <div>Generate unique shapes by AI</div>
                            <StyledButton :disabled="!prompt[index]" size="small" @click="generateShape(index)">Generate</StyledButton>
                        </div>

                        <div>
                            <StyledTextArea v-model="prompt[index]" label="Say something like 'Draw me a circle, the size should be 40px'" name="prompt" />
                        </div>
                        <div>Generated Shape Preview</div>
                        <!-- <div>{{ form.items[index].code }}</div> -->
                        <PreviewShapeComponent :preview-code="form.items[index].code" :scale="form.items[index].scale" />
                        <div>Adjust the size</div>
                        <slider
                            v-model="form.items[index].scale"
                            :always-show-handle="true"
                            color="#FB278D"
                            :handle-scale="2.5"
                            :min="0"
                            :max="2"
                            :step="0.1"
                            track-color="#bababa" />
                    </div>
                </div>
            </div>
        </div>
    </form>
</MainContentLayout>
</template>
